import axios from 'axios'
import { Message } from 'element-ui'

// 专门用于文件下载的axios实例
const downloadService = axios.create({
    baseURL: process.env.VUE_APP_REQUEST_URL || '/admin_xun_dian',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'application/json'
    },
    timeout: 300000,
    method: 'post',
    responseType: 'blob'
})

axios.defaults.withCredentials = true

downloadService.interceptors.request.use(
    (config) => {
        // 不使用qs处理，保持JSON格式
        return config
    },
    (error) => Promise.reject(error)
)

downloadService.interceptors.response.use(
    (res) => {
        // 直接返回blob数据
        return res.data
    },
    async (error) => {
        // 处理blob类型的错误响应
        if (error.response && error.response.data instanceof Blob) {
            try {
                const text = await error.response.data.text()
                const errorData = JSON.parse(text)
                Message.error(errorData.desc || errorData.message || '导出失败')
            } catch (e) {
                Message.error('导出失败')
            }
        } else {
            const errorMsg = error.response && error.response.data && error.response.data.message
            Message.error(errorMsg || '导出失败')
        }
        return Promise.reject(error)
    }
)

// 通用的文件下载处理函数
export function downloadFile(blob, filename) {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

export default downloadService
